<template>
  <el-dialog
      :visible="isVisible"
      @close="hide"
      :title="title"
      :destroy-on-close="true"
      width="80%"
  >
    <send-list-table v-if="hasUrl" :url="url"></send-list-table>
  </el-dialog>
</template>

<script>
import eventBus from "../../../../event-bus";
import SendListTable from './table';

export default {
  components: {
    SendListTable,
  },

  data() {
    return {
      isVisible: false,
      url: null,
    };
  },

  computed: {
    /**
     * @return {boolean}
     */
    hasUrl() {
      return Boolean(this.url);
    },

    /**
     * @return {string}
     */
    title() {
      return 'Send Lists';
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    show({url}) {
      this.isVisible = true;
      this.url = url;
    },

    /**
     * @return {undefined}
     */
    hide() {
      this.isVisible = false;
      this.url = null;
    },
  },

  created() {
    eventBus.$on('show-quick-add-to-send-lists', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-quick-add-to-send-lists', this.show);
  },
}
</script>
